import React from "react";
import { connect } from "react-redux";

import GroheMobile3dButton from "./groheMobile3dButton";
import FeatureName from "../../../../visComponents/featureName";
import FeatureThumbnail from "../../../../visComponents/featureThumbnail";
import {IS_PRODUCT_JOURNEY} from "../../../../../config";
import {getFeatureIsLocked} from "../../../../../misc/helpers";
import LookLockedButton from "../../../lookNavigation/lookMain/lookLockedButton";
import LookFeatureNotInStock from "../../../lookNavigation/lookMain/lookFeature/lookFeatureNotInStock";
import LookFeatureSku from "../../../lookNavigation/lookMain/lookFeature/lookFeatureSku";

const GroheMobileFeatureTop = (props) => {

  const {lookActiveFeature} = props;

  if (!lookActiveFeature) {
    return null
  }

  const featureIsLocked = getFeatureIsLocked(lookActiveFeature);

  return (
    <div className="gm-feature__top">
      <div className="gm-feature__top-thumbnail">
        <FeatureThumbnail feature={lookActiveFeature}
                          dbFeatureId={lookActiveFeature.dbFeature.id}/>
      </div>
      <div className="gm-feature__top-main">
        <div className="lk-title">
          <h2 className="lk-title__text bold"><FeatureName feature={lookActiveFeature} useCollectionName={true}/></h2>
        </div>
        <p className="lm-feature__content-model">
          <LookFeatureSku lookFeature={lookActiveFeature}/>
        </p>
        {!IS_PRODUCT_JOURNEY ? <LookFeatureNotInStock lookFeature={lookActiveFeature}/> : null}
      </div>
      <div className="gm-feature__top-right">
        {featureIsLocked ? <LookLockedButton className="lk-button__lock lk-button__lock--look"/> : <GroheMobile3dButton/>}
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {lookActiveFeature} = store.lookState;
  const {isPhoneNumberValidated} = store.userState; // to update component when user is logged in

  return {
    lookActiveFeature,
    isPhoneNumberValidated,
  };
};

export default connect(mapStateToProps)(GroheMobileFeatureTop)
